import React from "react";
import { Eye } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Run log list (read-only). `busy` = { id, action } of a request in flight.
export default function RunLogRowActions({ row, busy, onView }) {
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} busy={busy?.id === row.id} disabled={busy?.id === row.id} />
    </div>
  );
}
